import {
    GET_USER_DETAIL_REQUEST,
    GET_USER_DETAIL_FAIL,
    GET_USER_DETAIL_SUCCESS,
} from "../../constants/actions.js";
import { ApiURLs } from "../../../constant/ApiUrls.jsx";
import {  fetchData, } from "../../../services/api.js";


export const getUserDetailsRequest = (data, navigate) => {
  return async (dispatch) => {
    const url = `${ApiURLs.GET_USERS}/${data}`;
    // wait untill the data not received so getData function take data and url part
    dispatch(getUserDetailsReq());
    try {
      var userResData = await fetchData(url);
      console.log(`response when we try to login ${JSON.stringify(userResData)}`)
      if (userResData.status === 1) {
        dispatch(userDetailSuccess(userResData.data));
      
      } else {
        dispatch(userDetailsFailure());
      }
    } catch (error) {
      dispatch(userDetailsFailure());
      console.log(`error while try to login ${error}`)
    }
  }
};


export const getUserDetailsReq = () => {
  return {
    type: GET_USER_DETAIL_REQUEST,
  };
};

export const userDetailSuccess = (userDetails) => {
  console.log(`user details is geteted success ${JSON.stringify(userDetails)}`);
  return {
    type: GET_USER_DETAIL_SUCCESS,
    payload: userDetails,
  };
};

export const userDetailsFailure = () => {
  return {
    type: GET_USER_DETAIL_FAIL,
  };
};


